import { useEffect, useState } from "react";

/** Delays reflecting a fast-changing value (e.g. a text filter input) so a
 * live/reactive query doesn't re-fetch on every keystroke. */
export function useDebounce<T>(value: T, delayMs = 400): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
